import { Overlay, useOverlay } from './Overlay';
Overlay.useOverlay = useOverlay;
export default Overlay;
